/**
 * API Endpoints
 * ---
 * Details for app integrations.
 */

const apiEndpoints = {
  dev: 'https://shopifyap21app-dev.testarc.com.au/',
  prod: 'https://shopifyap21app.testarc.com.au/'
};
function getApiEndpoint() {
  return Shopify.shop == 'annathomas-dev.myshopify.com' ? apiEndpoints.dev : apiEndpoints.prod;
}

export const apiEndpoint = getApiEndpoint();